import { toCSSColor, toRGBA } from '@printu/geom';
// const DefaultStyle: Style = {
//     // Paths
//     fillColor: null,
//     fillRule: 'nonzero',
//     strokeColor: null,
//     strokeWidth: 1,
//     strokeCap: 'butt',
//     strokeJoin: 'miter',
//     strokeScaling: true,
//     miterLimit: 10,
//     dashOffset: 0,
//     dashArray: [],
//     // Shadows
//     shadowColor: null,
//     shadowBlur: 0,
//     shadowOffset: new Point(),
//     // Selection
//     selectedColor: null,
//     // Characters
//     fontFamily: 'sans-serif',
//     fontWeight: 'normal',
//     fontSize: 12,
//     leading: null,
//     // Paragraphs
//     justification: 'left'
// };
// DOCS: Style#hasFill()
const hasFill = (style) => !!style.fillColor && toRGBA(style.fillColor).alpha > 0;
const hasStroke = (style) => !!style.strokeColor &&
    toRGBA(style.strokeColor).alpha > 0 &&
    style.strokeWidth > 0;
const hasShadow = (style) => 
// In order to draw a shadow, we need either a shadow blur or an
// offset, or both.
!!style.shadowColor &&
    toRGBA(style.shadowColor).alpha > 0 &&
    (style.shadowBlur > 0 || !style.shadowOffset);
export const setStyles = (ctx, style, _params = null, _viewMatrix = null) => {
    if (hasFill(style)) {
        ctx.fillStyle = toCSSColor(style.fillColor); // style.getFillColor().toCanvasStyle(ctx, matrix);
    }
    if (hasStroke(style)) {
        ctx.strokeStyle = toCSSColor(style.strokeColor); // style.getStrokeColor().toCanvasStyle(ctx, matrix);
        ctx.lineWidth = style.strokeWidth;
        const { strokeJoin } = style;
        const { strokeCap } = style;
        const { miterLimit } = style;
        if (strokeJoin) {
            ctx.lineJoin = strokeJoin;
        }
        if (strokeCap) {
            ctx.lineCap = strokeCap;
        }
        if (miterLimit) {
            ctx.miterLimit = miterLimit;
        }
    }
    if (hasShadow(style)) {
        const offset = style.shadowOffset;
        const blur = style.shadowBlur;
        ctx.shadowColor = toCSSColor(style.shadowColor); // style.getShadowColor().toCanvasStyle(ctx);
        ctx.shadowBlur = blur; // .getLength();
        ctx.shadowOffsetX = offset.x;
        ctx.shadowOffsetY = offset.y;
    }
    else {
        ctx.shadowColor = undefined;
        ctx.shadowBlur = undefined;
        ctx.shadowOffsetX = undefined;
        ctx.shadowOffsetY = undefined;
    }
};
export function extractStyle(style, keys, defaults) {
    return keys.reduce((accum, key) => {
        var _a;
        accum[key] = (_a = style[key]) !== null && _a !== void 0 ? _a : defaults[key];
        return accum;
    }, {});
}
